import React, { useEffect, useState } from 'react'

import { API } from 'aws-amplify'
import { updateOrganization } from '../../managers/graphql/mutations'

// mui
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// redux
import { useAppDispatch, useAppSelector } from '../../hooks'
import { setLoading } from '../../managers/redux/slices/loading'
import { toast } from 'react-toastify'
import AmbassadorSettings from '../../components/settings/Ambassadors'
import NotificationSettings from '../../components/settings/Notifications'

export default function Settings(props: any) {

    // redux
    const dispatch = useAppDispatch()
    const fundraising = useAppSelector(state => state.fundraising)
    const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)

    const [selectedTab, setSelectedTab] = useState<number>(0)

    return (
        <div className="d-flex flex-column justify-content-start align-items-start w-100">
            <Tabs value={selectedTab} onChange={(e, value) => setSelectedTab(value)} className="bg-white w-100 pt-5 ps-5">
                <Tab label={selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverridePlural ? selectedStaffProfile.organization.ambassadorTermOverridePlural : 'Ambassadors'} />
                <Tab label="Notifications" />
            </Tabs>
            <div className="px-5">
                {
                    selectedTab == 0 ?
                        <AmbassadorSettings />
                        :
                        selectedTab == 1 ?
                            <NotificationSettings />
                            :
                            <div></div>
                }
            </div>
        </div>
    )
}